import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import classnames from 'classnames';
import { ArrowUp, ArrowDown } from './SvgIcons';

class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
    this.toggleOpen = this.toggleOpen.bind(this);
  }
  UNSAFE_componentWillMount() {
    if (this.props.open) {
      this.setState({
        open: this.props.open,
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.forceOpen !== undefined &&
      this.props.forceOpen !== nextProps.forceOpen
    ) {
      this.setState({ open: nextProps.forceOpen });
    }
  }
  toggleOpen = (event) => {
    const { permissionInfo, setErrors } = this.props;
    if (
      this.props.hasOwnProperty('permissionInfo') &&
      !permissionInfo.allowed
    ) {
      setErrors(permissionInfo.errorMessage);
      return;
    }

    if (
      event.target.name !== 'link' &&
      !event.target.id?.startsWith('adv-permission-toggle')
    ) {
      const { name, onToggle } = this.props;
      if (onToggle) {
        const fakeEvent = {
          target: {
            value: !this.state.open,
            name: name,
          },
        };
        onToggle(fakeEvent);
      }

      this.setState({
        open: !this.state.open,
      });
    }
  };

  handleHeaderClick = (event) => {
    if (this.props.useHeaderAsLink === false) {
      return;
    }
    this.toggleOpen(event)
  }

  render() {
    const {
      id,
      className,
      header,
      footer,
      content,
      toggleIconOpen,
      toggleIconClosed,
      customToggles,
      grayBG,
      headerBackgroundColor,
      border,
      hasBorderBottom,
      appendToHeader,
      style
    } = this.props;
    const { open } = this.state;
    let openIcon;
    let closeIcon;
    if (customToggles) {
      openIcon = toggleIconOpen;
      closeIcon = toggleIconClosed;
    } else {
      openIcon = <ArrowUp />;
      closeIcon = <ArrowDown />;
    }

    let contentEvaluated =
      content instanceof Function
        ? content({ onClose: this.toggleOpen })
        : content;

    return (
      <div
        id={id}
        className={'accordian ' + (className ? className : '')}
        style={style}
        onMouseEnter={this.props.onMouseEnter || null}
        onMouseLeave={this.props.onMouseLeave || null}
      >
        {content && (
          <a
            id={id ? id + '_toggle' : null}
            onClick={this.toggleOpen}
            className={classnames({
              btnCollapse: open,
              btnExpand: !open,
            })}
          >
            {open ? closeIcon : openIcon}
          </a>
        )}
        <div
          className={classnames({
            header: true,
            grayBG: grayBG && open,
            accordionBorderBottom: open && hasBorderBottom,
          })}
          style={{ backgroundColor: headerBackgroundColor || null }}
          onClick={this.handleHeaderClick}
        >
          {header}
          {open && appendToHeader}
        </div>
        {open && content && (
          <div
            className={classnames({
              content: true,
              grayBG: grayBG && open,
              accordionBorder: border,
            })}
            style={{ borderColor: headerBackgroundColor }}
          >
            {contentEvaluated}
          </div>
        )}
        {footer && (
          <div
            className={classnames({
              footer: true,
              grayBG: grayBG && open
            })}
          >
            {footer}
          </div>
        )}
      </div>
    );
  }
}

Accordion.propTypes = {
  header: PropTypes.node,
  footer: PropTypes.node,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onToggle: PropTypes.func,
  useHeaderAsLink: PropTypes.bool,
  toggleIconOpen: PropTypes.node,
  toggleIconClosed: PropTypes.node,
  customToggles: PropTypes.bool,
  grayBG: PropTypes.bool,
  headerBackgroundColor: PropTypes.string,
  border: PropTypes.bool,
  hasBorderBottom: PropTypes.bool,
  appendToHeader: PropTypes.node,
  open: PropTypes.bool,
};

Accordion.defaultProps = {
  onToggle: () => {},
  useHeaderAsLink: true,
};

export default connect(null, actions)(Accordion);
